import { render, staticRenderFns } from "./modelDeatail.vue?vue&type=template&id=54aa3af4&scoped=true"
import script from "./modelDeatail.vue?vue&type=script&lang=js"
export * from "./modelDeatail.vue?vue&type=script&lang=js"
import style0 from "./modelDeatail.vue?vue&type=style&index=0&id=54aa3af4&prod&lang=scss"
import style1 from "./modelDeatail.vue?vue&type=style&index=1&id=54aa3af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa3af4",
  null
  
)

export default component.exports